import React from 'react';

import { Modal, ModalContent, ModalHeading, ModalProps } from '@uikit/index';

interface ConfirmBoostModalProps extends Omit<ModalProps, 'children'> {
  setBoosted: (props: boolean) => void;
}

export const ConfirmBoostModal = (props: ConfirmBoostModalProps) => {
  const handleBoostChange = (value: boolean) => {
    props?.setBoosted?.(value);
    props?.onOpenChange?.(false);
  };

  return (
    <Modal {...props}>
      <ModalContent className="flex flex-col items-center p-6 sm:px-12 text-center w-full max-w-[555px]">
        <ModalHeading className="mb-4">Activate Turbo Charge for Previous Deposits</ModalHeading>
        <div className="flex flex-col gap-4">
          <p className="text-neutral-400">
            By selecting Turbo Charge for your current deposit, all your previous deposits to this
            pool will also be retroactively turbo charged according to the current market
            conditions. This means your total allocation boost (your Buying Power) will be
            recalculated based on the current Turbo Charge parameters. Please confirm if you wish to
            proceed with this change.
          </p>
          <p className="text-neutral-400 font-semibold">
            Do you want to activate Turbo Charge for all your previous deposits?
          </p>
          <button onClick={() => handleBoostChange(true)} className="button button-secondary">
            Yes, Activate Turbo Charge for All My Deposits
          </button>
          <button onClick={() => handleBoostChange(false)} className="button button-secondary">
            No, Keep My Deposits as They Are
          </button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmBoostModal;
